'use client';

import React, { type CSSProperties, type ReactNode } from 'react';
import { useColors } from '../theme/ThemeProvider';
import { fontSize, fontWeight, letterSpacing } from '../theme/tokens';

export interface LabelProps {
  children: ReactNode;
  /** Text tone. Defaults to "dim". */
  tone?: 'primary' | 'dim' | 'muted';
  /** Emphasis via tracking+size. Defaults to "micro". */
  variant?: 'micro' | 'caption';
  style?: CSSProperties;
}

/**
 * Uniform micro/caption text for labels like "CALORIES", "TODAY".
 */
export function Label({
  children,
  tone = 'dim',
  variant = 'micro',
  style,
}: LabelProps) {
  const colors = useColors();
  const color =
    tone === 'primary' ? colors.text : tone === 'muted' ? colors.textMuted : colors.textDim;

  return (
    <div
      style={{
        color,
        fontSize: variant === 'micro' ? fontSize.xs : fontSize.sm,
        fontWeight: fontWeight.semibold,
        letterSpacing: variant === 'micro' ? letterSpacing.wide : letterSpacing.normal,
        textTransform: variant === 'micro' ? 'uppercase' : undefined,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
